import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const WelcomeMessageForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        // image: editData?.image || '',
        btn_name: editData?.btn_name || '',
        btn_link: editData?.btn_link || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };
    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            {/* 
            <Form.Group className='mt-3'>
                <FormLabel title='Image' required />

                <ReactInput name='image' type='file' />
            </Form.Group>
            */}

            <Form.Group className='mt-3'>
                <FormLabel title='Button Name' required />

                <ReactInput name='btn_name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Button link' required />

                <ReactInput name='btn_link' />
            </Form.Group>

            {/* <Form.Group className='mt-3'>
                <FormLabel title='Description' required />

                <ReactInput name='description' as='textarea' rows={6} />
            </Form.Group> */}

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default WelcomeMessageForm;
